// @flow

import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-modal";
import { useDropzone } from "react-dropzone";
import { showFileUploadModal } from "src/actions/file";

import type { RoomId } from "src/types";

import { getCurrentRoomAccess, getFileUploadModalStatus } from "src/reducers";
import { currentRoomAccessStatuses } from "src/reducers/chatRooms";
import Warning from "./Warning";
import StyledModal, { ModalContent } from "./styles";
import ChatHistory from "src/components/messages/History";
import ChatroomHeader from "src/containers/chatroom/Dialog/Header";
import ChatInput from "src/components/chatroom/Input";
import RestrictedModal from "src/components/chatroom/RestrictedModal";
import PreviewModal from "src/components/file/PreviewModal";
import { getParent } from "src/utils";

type Props = {
  roomId: RoomId,
  show: boolean,
  warn: boolean,
  closeConversationModal: Function,
};

const Dialog = ({ roomId, show, warn, closeConversationModal }: Props) => {
  const dispatch = useDispatch();

  const currentRoomRestricted = useSelector(
    ({ app }) =>
      getCurrentRoomAccess(app) === currentRoomAccessStatuses.restricted,
  );
  const showFilesPreviewModal = useSelector(({ app }) =>
    getFileUploadModalStatus(app, roomId),
  );

  const onDrop = (acceptedFiles) => {
    dispatch(showFileUploadModal({ viewId: roomId, files: acceptedFiles }));
  };

  const { getRootProps, isDragActive } = useDropzone({ onDrop });

  return currentRoomRestricted ? (
    <RestrictedModal />
  ) : (
    <>
      <StyledModal id="conversation-dialog">
        <Modal
          isOpen={show}
          onRequestClose={closeConversationModal}
          parentSelector={() => getParent("#conversation-dialog")}
          shouldCloseOnOverlayClick={false}
        >
          {showFilesPreviewModal && <PreviewModal roomId={roomId} />}
          <ModalContent {...getRootProps()} isDragActive={isDragActive}>
            <ChatroomHeader roomId={roomId} />
            <ChatHistory roomId={roomId} />
            <ChatInput roomId={roomId} />
          </ModalContent>
        </Modal>
      </StyledModal>
      {warn ? <Warning roomId={roomId} /> : null}
    </>
  );
};

export default Dialog;
